<template>
    <div id="addresscheck">
        <div class="box">
            <div class="top">
                <div class="text">地址选择</div>
                <div class="close_btn" @click="this.closedig()">x</div>
            </div>
            <div class="content">
                <div class="c_top">
                        <div class="input_box">
                            <input type="text" placeholder="请输入地址信息" v-model="searchAdrressStr" @input="this.searchAddress">
                            <a href="javascript:void(0);">搜索</a>
                        </div>
                        <div class="addr_tishi" v-if="is_tishi">
                            <ul>
                                <li v-for="item in address" @click="this.inputliclickfun(item)">
                                    <span class="title">{{ item.title }}</span>
                                    <span class="adrr_txt">{{ item.address }}</span>
                                </li>
                                
                            </ul>
                        </div>
                </div>
                <div class="con_box">
                    <div class="mapbox" id="map">
                        
                    </div>
                    <div class="right">
                        <div class="tui_top">
                            推荐地址：
                        </div>
                        <ul>
                                <li v-for="item in tuiaddress" @click="this.tuiliclikefun(item)">
                                    <span class="title">{{ item.title }}</span>
                                    <span class="adrr_txt">{{ item.address }}</span>
                                </li>
                                
                        </ul>
                    </div>
                </div>
                <div class="con_footer">
                    选中地址：{{ chooseAdrr }}
                </div>
            </div>
            <div class="footer">
                <a href="javascript:void(0)" @click="this.closedig()">取消</a>
                <a href="javascript:void(0)" @click="this.iscomimt()">确定</a>
            </div>
        </div>
    </div>

</template>

<script>
import {jsonp} from 'vue-jsonp';
import { ElMessage } from 'element-plus';
export default{
    name:"addresscheck",
    data(){
        return{
            is_tishi:false,
            longitude:106.628221,
            latitude: 26.646631,
            city: '',
            mapInstance: null, // 保存地图实例
            markerInstance: null ,// 保存标记实例
            searchAdrressStr:'',
            address:[],
            key:'GNLBZ-P32RI-QSGGW-U3TJE-BH4OE-QNFLN',
            tuiaddress:[],
            chooseAdrr:'',
            return_address:{
                longitude:0,
                latitude:0,
                address_str:''
            },
        }
    },
    props: {
        modelValue: {
                // type: Array,
                default:""
            },
    },
    mounted(){
        this.latitude=this.modelValue.latitude
        this.longitude=this.modelValue.longitude
        this.chooseAdrr=this.modelValue.address_str
        this.setMap()
    },
    methods:{
        closedig(){
            this.$emit('closedig')
        },
        iscomimt(){
            if(this.chooseAdrr==''){
                ElMessage({ message: "请选择地址", type: 'error', duration: 1500 });
                return false
            }
            this.return_address={
                longitude:this.longitude,
                latitude:this.latitude,
                address_str:this.chooseAdrr
            }
            console.log(this.return_address)
            this.$emit('update:modelValue',this.return_address)
            this.closedig()
        },
        setMap() {
                var myLatlng = new qq.maps.LatLng(this.latitude, this.longitude);
                var myOptions = {
                    zoom: 15,
                    center: myLatlng,
                    mapTypeId: qq.maps.MapTypeId.ROADMAP
                }
               
                // 保存地图实例，避免重复创建
                if (!this.mapInstance) {
                    this.mapInstance = new qq.maps.Map(document.getElementById("map"), myOptions);
                    this.markerInstance = new qq.maps.Marker({
                        position: new qq.maps.LatLng(this.latitude, this.longitude),
                        map: this.mapInstance
                    });
                    // 【关键修复】使用箭头函数 => 保证 this 指向 Vue 实例
                    qq.maps.event.addListener(this.mapInstance, 'click', (event) => {
                    this.longitude = event.latLng.getLng();
                    this.latitude = event.latLng.getLat();
                    
                    if (this.markerInstance) {
                        this.markerInstance.setMap(null);
                        this.markerInstance = null;
                    }
                    
                    this.markerInstance = new qq.maps.Marker({
                        position: new qq.maps.LatLng(this.latitude, this.longitude),
                        map: this.mapInstance
                    });
                    
                    // 现在 this 正确指向 Vue 实例
                        this.getAddress();
                    });
                } else {
                    // 如果地图已存在，仅更新中心点
                    this.mapInstance.setCenter(myLatlng);
                }
        },
        inputliclickfun(item){
           this.chooseAdrr=item.address
           this.latitude=item.location.lat
           this.longitude=item.location.lng
           this.setMarker()
           this.is_tishi=false
           this.address=[]
        },
        setMarker(){
                 if (this.markerInstance) {
                        this.markerInstance.setMap(null);
                        this.markerInstance = null;
                    }
                    
                    this.markerInstance = new qq.maps.Marker({
                        position: new qq.maps.LatLng(this.latitude, this.longitude),
                        map: this.mapInstance
                    });
                    this.mapInstance.setCenter(new qq.maps.LatLng(this.latitude, this.longitude));
        },
        tuiliclikefun(item){
            this.chooseAdrr=item.address
            this.latitude=item.location.lat
            this.longitude=item.location.lng
            this.setMarker()
        },
        //地址转坐标
        searchAddress(){ 
            this.tuiaddress=[]
            this.is_tishi=false
            this.address=[]
            const date=jsonp("https://apis.map.qq.com/ws/geocoder/v1/?address="+this.searchAdrressStr+"&key="+this.key+"&output=jsonp&policy=1",{}).then(data=>{
                if(data.status==0){ 
                        this.latitude=data.result.location.lat;
                        this.longitude=data.result.location.lng;
                        let region=data.result.ad_info.adcode;
                        this.roundSearchAdrress(region);
                }
            })
        },
        //关键字查询
        roundSearchAdrress(area){ 
                const date=jsonp("https://apis.map.qq.com/ws/place/v1/suggestion/?keyword="+this.searchAdrressStr+"&location="+this.latitude+","+this.longitude+"&key="+this.key+"&policy=1&page_size=20&region="+area+"&region_fix=1&output=jsonp",{}).then(data=>{
                    if(data.status==0){ 
                            this.address=data.data
                            if(this.address.length>0){
                                this.is_tishi=true
                            }
                            console.log(this.address)
                    }
                })

        },
        //坐标转地址
        getAddress() {
            const date=jsonp("https://apis.map.qq.com/ws/geocoder/v1?location="+this.latitude+","+this.longitude+"&key="+this.key+"&get_poi=1&output=jsonp",{}).then(data=>{
                if(data.status==0){
                    this.tuiaddress=data.result.pois
                }
            })
    }
 }
}


</script>
<style scoped>
#addresscheck{
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 100;
    background-color: rgba(0, 0, 0, 0.6);
    left: 0;
    top: 0;
}
#addresscheck .box{
    width: 800px;
    height: 600px;
    position: relative;
    left: 50%;
    top: 50%;
    margin-top: -300px;
    margin-left:-400px;
    background-color: #fff;
    border-radius: 10px;
    overflow:hidden;
}
#addresscheck .box .top{
    width: 100%;
    height: 40px;
    float: left;
    line-height: 40px;
    font-size: 18px;
    padding-left: 5px;
    color: #2d2d2d;
}
#addresscheck .box .top .text{
    width: 200px;
    height: 40px;
    float: left;
    line-height: 40px;
    font-size: 18px;
    color: #2d2d2d;
    padding-left: 10px;
}
#addresscheck .box .top .close_btn{
    width: 40px;
    height: 40px;
    float: right;
    line-height: 40px;
    font-size: 24px;
    color: #2d2d2d;
    text-align: center;
    cursor: pointer;
}
#addresscheck .box .content{
    width: 100%;
    height: 500px;
    float: left;
    padding: 10px 10px;
}
#addresscheck .box .content .c_top{
    width: 100%;
    height: 40px;
    float: left;
    border: 1px solid #ccc;
    border-radius: 5px;
    position: relative;
}
#addresscheck .box .content .c_top .input_box{
    width: 100%;
    height: 100%;
    float: left;
    overflow: hidden;
}
#addresscheck .box .content .c_top .input_box input{
    width: calc( 100% - 80px );
    height: 100%;
    float: left;
    outline: none;
    border: none;
    padding: 0 5px;
    font-size: 14px;
    color: #2d2d2d;
    border-right: 1px solid #ccc;
}
#addresscheck .box .content .c_top .input_box a{
    width: 80px;
    height: 100%;
    float: left;
    background-color: #60a2db;
    text-align: center;
    font-size: 14px;
    line-height: 40px;
    text-decoration: none;
    color: #fff;
}
#addresscheck .box .content .c_top .input_box a:hover{
    background-color: #3b82c0;
}
#addresscheck .box .content .c_top .addr_tishi{
    width: 100%;
    height: 150px;
    float: left;
    background-color: #fff;
    margin-top: 1px;
    border:1px solid #ccc;
    overflow: hidden;
    overflow-y: scroll;
    position: relative;
    z-index: 50;
}
#addresscheck .box .content .c_top .addr_tishi ul{
    width: 100%;
    height: auto;
    float: left;
    margin: 0;
    padding: 5px 10px;
}
#addresscheck .box .content .c_top .addr_tishi ul li{
    width: 100%;
    height: 40px;
    float: left;
    list-style: none;
    padding: 0 10px;
    cursor: pointer;
}
#addresscheck .box .content .c_top .addr_tishi ul li:hover{
    background-color: #c9c8c8;
}
#addresscheck .box .content .c_top .addr_tishi ul li .title{
    width: 100%;
    height: 20px;
    float: left;
    color: #2d2d2d;
    line-height: 20px;
    font-size: 14px;
}
#addresscheck .box .content .c_top .addr_tishi ul li .adrr_txt{
    width: 100%;
    height: 15px;
    float: left;
    color: #4d4c4c;
    line-height: 15px;
    font-size: 12px;
}
#addresscheck .box .content .con_box{
    width: 100%;
    height: 400px;
    float: left;
    padding: 0 10px;
    margin-top: 10px;
    overflow: hidden;
}
#addresscheck .box .content .con_box .mapbox{
    width: 400px;
    height: 400px;
    float: left;
    border: 1px solid #ccc;
}
#addresscheck .box .content .con_box .right{
    width: 340px;
    height: 100%;
    float: right;
}
#addresscheck .box .content .con_box .right .tui_top{
    width: 100%;
    height: 40px;
    float: left;
    line-height: 40px;
    color: #2d2d2d;
    font-size: 16px;
}
#addresscheck .box .content .con_box .right ul{
    width: 100%;
    height: 360px;
    float: left;
    overflow: hidden;
    overflow-y: scroll;
    padding: 0;
    margin: 0;
}
#addresscheck .box .content .con_box .right ul li{
    width: 100%;
    height: 50px;
    float: left;
    list-style: none;
    padding: 0 10px;
    cursor: pointer;
}

#addresscheck .box .content .con_box .right ul li:hover{
    background-color: #c9c8c8;
}
#addresscheck .box .content .con_box .right ul li .title{
    width: 100%;
    height: 20px;
    float: left;
    color: #2d2d2d;
    line-height: 20px;
    font-size: 14px;
}
#addresscheck .box .content .con_box .right ul li .adrr_txt{
    width: 100%;
    height: 30px;
    float: left;
    color: #4d4c4c;
    line-height: 15px;
    font-size: 12px;
}
#addresscheck .box .content .con_footer{
    width: 100%;
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    color: #2d2d2d;
    float: left;
}
#addresscheck .box .footer{
    width: 100%;
    height: 40px;
    float: left;
}
#addresscheck .box .footer a{
    width: 80px;
    height: 100%;
    border-radius: 5px;
    float: left;
    line-height: 40px;
    color: #fff;
    font-size: 14px;
    text-align: center;
    text-decoration: none;
}
#addresscheck .box .footer a:nth-child(1){
    background-color: #fb3a05;
    margin-left: 300px;
    margin-right: 10px;
}
#addresscheck .box .footer a:nth-child(2){
    background-color: #09b228;
}
</style>